import { ApiService } from "./";

class OnboardService {
  request(clientId: string) {
    return ApiService.api.post(`/onboard/${clientId}`);
  }
}
const singleton = new OnboardService();
export default singleton;
